import React, {useEffect, useState} from 'react';
import {modals, sftpConfigs} from "../../../ducks";
import duckify, {filterDuck, singleDuck} from "../../../utils/duckify";
import PageHeader from "../../PageHeader";
import ContactList from "../../ContactList/ContactList";
import FALabel from "../../shared/FALabel";
import LinkButton from "../../LinkButton/LinkButton";
import ModalRoot from "../../ModalRoot";
import EditSftpModal from "./EditSftpModal";
import {compose} from "redux";
import withFiltering from "../../../hocs/withFiltering";
import withPagination from "../../../hocs/withPagination";
import withSorting from "../../../hocs/withSorting";
import Pagination from "react-ultimate-pagination-bootstrap-4";
import {defaultColumn} from "../../ContactList/ColumnDefinitions";
import {apiFetch} from "../../../utils";
import {faCheckCircle as faCheckCircleSolid} from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import {faBan} from "@fortawesome/pro-solid-svg-icons/faBan";
import FA from "../../../utils/FA";

const SftpListPage = ({
  configs,
  onEditSftp,
  onDeleteSftp,
  onTest,
  onSort,
  page,
  setPage,
  sort
}) => {
  const [ipAddresses, setIpAddresses] = useState([]);
  const [testing, setTesting] = useState([]);

  useEffect(() => {
    apiFetch.get({}, 'sftp_configs/ip_addresses')
      .then(json => {
        setIpAddresses(json.ip_addresses || []);
      });
  }, []);

  const columns = [
    defaultColumn({
      header: 'SFTP Host Name',
      value: 'host'
    }),
    defaultColumn({
      header: 'Port',
      value: 'port'
    }),
    defaultColumn({
      header: 'Directory',
      value: 'directory'
    }),
    defaultColumn({
      header: 'Display Name',
      value: 'display_name'
    }),
    defaultColumn({
      header: 'Configured?',
      value: config => <td><FA style={{color: config.configured ? 'green' : 'red'}} icon={config.configured ? faCheckCircleSolid : faBan} /></td>
    }),
    defaultColumn({
      header: '',
      value: config => (
        <td>
          {testing.includes(config.id) ? "Testing..." : <LinkButton onClick={() => onTest(config, testing, setTesting)} content={"Test Connection"} />}{' | '}
          <LinkButton onClick={() => onEditSftp(config)} content="Edit" />{' | '}
          <LinkButton onClick={() => onDeleteSftp(config)} content="Delete" />
        </td>
      )
    })
  ]

  const totalPages = configs ? Math.ceil(configs.total / configs.perPage) : 0;

  return <React.Fragment>
    <PageHeader header="SFTP Setup" />

    <h3>
      Finalsite Enrollment SFTP exports may come from any of the following IP addresses:
      {ipAddresses.map(address => <><br/>{address}</>)}
      <br/>
      Please configure your firewall to allow incoming connections from these IP addresses on the port you specified or port 22 if you did not specify.
      <br/>
      Note that this list may change in the future.
    </h3>

    <div>
      <LinkButton
        className="add-item-button"
        content={<FALabel icon="plus-circle" iconFirst label=" Add a new SFTP configuration" />}
        onClick={() => onEditSftp(undefined)}
      />
    </div>

    {totalPages > 1 && (
      <div className='contact-list-react-pagination'>
        <div className='pagination pagination-right'>
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            hideFirstAndLastPageLinks
            onChange={setPage}
          />
        </div>
      </div>
    )}

    <ContactList
      className="table-hover"
      columns={columns}
      contacts={configs}
      emptyMessage="No SFTP configurations"
      onSort={onSort}
      sort={sort}
    />

    <ModalRoot modals={{ EditSftpModal }} />
  </React.Fragment>;
};

const mapDucksToProps = ({filters, sort, page, perPage}) => ({
  configs: filterDuck(sftpConfigs, {filters, sort, page: page || 1, per_page: perPage})
});

const mapDispatchToProps = (dispatch) => ({
  onEditSftp: (config) => dispatch(modals.actions.show('EditSftpModal', { sftpConfig: config })),
  onDeleteSftp: config => dispatch(modals.actions.show('VerificationModal', {
    confirmButtonType: 'primary',
    message: (<>
      <p>You have chosen to delete the configuration for {config.host}.</p>
      <p>SFTP configurations can only be deleted if they are not linked to any scheduled exports.</p>
    </>),
    confirmText: 'Delete',
    onConfirm: () => dispatch(sftpConfigs.actions.remove(config))
      .then(() => dispatch(sftpConfigs.actions.markDirty()))
      .catch(response => {
        Utility.displayFlashMessages({ error: `Failed to delete configuration${response.error ? `: ${response.error}` : ''}` });
      }),
    title: 'Delete SFTP Configuration',
    onClose: () => dispatch(modals.actions.hide()),
  })),
  onTest: (sftpConfig, testing, setTesting) => {
    const name = sftpConfig.display_name || sftpConfig.host;
    setTesting([...testing, sftpConfig.id]);
    return apiFetch.get({}, `sftp_configs/${sftpConfig.id}/test_sftp_config`)
      .then(() => {
        setTesting(testing.filter(id => id !== sftpConfig.id));
        Utility.displayFlashMessages({success: `${name}: Test Login Successful`})
      })
      .catch(response => {
        setTesting(testing.filter(id => id !== sftpConfig.id));
        Utility.displayFlashMessages({error: `${name ? `${name}: `: ''}${response.error || 'Test Login Failed'}`});
      })
  },
});

export default compose(
  withFiltering,
  withPagination,
  withSorting({column: 'name', order: 'asc'}),
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(SftpListPage);
